<template>
  <div
    class="container"
    :style="{
      background:
        'url(' +
        require('../../assets/img/' + bei_ing) +
        ') no-repeat center center',
      'background-size': '100% 100%',
    }"
  >
    <dingbu></dingbu>
    <div class="home_content">
      <div class="bg_color">
        <div class="w">
          <div class="inform__box">
            <div class="box__top">
              <span class="shou__ye">首页</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <router-link
                class="ton__zhi2"
                tag="span"
                :to="{ path: '/profile', query: { id: this.id } }"
                >学习系统</router-link
              >
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi2" @click="wodekaoshi">我的考试</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi">考试须知</span>
            </div>
          </div>
          <div class="box-contentvb">
            <div class="kasohi-xuzghi">
              <img
                class="kaoshi_img"
                src="../../assets/kaoshixuzhi_img@2x.png"
                alt
              />
            </div>
            <div class="kaoshi-right">
              <div class="kaoshi-xuzhi-title">考试须知</div>
              <div class="xuzhi-xian"></div>
              <div class="xuzhi-text" v-html="extrm.content"></div>
              <div class="kaishi-kao" @click="kaikao">开始考试</div>
            </div>
          </div>
        </div>
        <dibu></dibu>
        <daohan></daohan>
      </div>
    </div>
  </div>
</template>

<script>
import daohan from "../daohan";
import dibu from "../dibu";
import dingbu from "../dingbu";
export default {
  components: {
    daohan,
    dibu,

    dingbu
  },
  data() {
    return {
      extrm: [],
      id: "",
      bei_ing: this.Public.bei_ing,

    };
  },
  mounted() {
    this.getexamtext();
    this.id = this.id = this.$route.query.id;
  },
  methods: {
    //我的考試
    wodekaoshi() {
      this.$router.push({ path: "/profile", query: { id: this.id } });
    },
    //点击开始考试
    kaikao() {
      let that = this;
      var url = "exam/examnum";
      let param = {
        study_id: this.id,
      };
      this.post(url, param)
        .then((res) => {
          // console.log(res)
          if (res.code == 0) {
            // this.$message(res.msg);
          } else {
            this.$router.push({ path: "/answer", query: { id: this.id } });
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    //考试须知接口
    getexamtext() {
      let that = this;
      var url = "exam/examtext";
      let param = {};
      this.post(url)
        .then((res) => {
          this.extrm = res.data;
          // console.log(res);
        })
        .catch((err) => {
          // console.log(err);
        });
    },
  },
};
</script>
<style scoped>
@import "../../css/exam.css";
</style>